import { AccountLibraryDeps } from '../AccountLibraryDeps'
import { ContentPicker, type ContentPickerProps } from './ContentPicker'

/** The content picker for screens without Library dependencies of their own (the chat composer). */
export function AccountContentPicker(props: ContentPickerProps) {
  return (
    <AccountLibraryDeps accountId={props.accountId}>
      <ContentPicker {...props} />
    </AccountLibraryDeps>
  )
}
